import React from "react";
import PropTypes from "prop-types";
import {
  Card,
  CardBody,
  CardHeader,
  Chip,
  Typography,
} from "@material-tailwind/react";
import "./IndividualExperience.css";

const IndividualExperience = ({
  from,
  to,
  company,
  position,
  type,
  description,
  stack,
  animationDelay = 0,
}) => {
  const delayStyle = {
    animationDelay: `${animationDelay * 0.1}s`,
  };

  return (
    <Card className="experience-card" style={delayStyle}>
      <CardHeader
        shadow={false}
        floated={false}
        color="transparent"
        className="experience-date"
      >
        <Typography variant="h6" className="date-text">
          {from} - {to}
        </Typography>
      </CardHeader>
      <CardBody className="experience-body">
        <div>
          <Typography variant="h3" className="company-name">
            {company}
          </Typography>
          <Typography variant="h5" className="position-title">
            {position}
          </Typography>
          <Typography className="employment-type">
            {type}
          </Typography>

          <Typography className="date-mobile">
            {from} - {to}
          </Typography>
          <Typography className="experience-description">
            {description}
          </Typography>
        </div>
        <div className="stack-container">
          <div className="stack-chips">
            {stack.map((tech, index) => {
              return (
                <Chip
                  key={index}
                  variant="outlined"
                  color="blue"
                  value={tech}
                  className="stack-chip"
                />
              );
            })}
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

IndividualExperience.propTypes = {
  from: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  company: PropTypes.string.isRequired,
  position: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  stack: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default IndividualExperience;